import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { I18nProvider } from "./lib/i18n";
import PublicSite from "./pages/PublicSite";
import Admin from "./pages/Admin";

function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PublicSite />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <Toaster theme="dark" richColors position="top-right" />
      </BrowserRouter>
    </I18nProvider>
  );
}

export default App;
